<template>
  <div class="TemplateForm">
    <el-form class="template-box" :model="form" ref="ruleForm" label-width="180px">
      <el-col :span="8">
        <el-form-item :label="$t('lang.programName')" prop="templateName" required>
          <el-input v-model="form.templateName" @input="PushUndo('input')" @change="PushUndo('inputEnd')" auth-typecomplete="off" maxlength="128" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.Series')}:`">
          <el-input v-model="form.series" @change="PushUndo('inputEnd')"  auth-typecomplete="off" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.EpisodeTitle')}:`">
          <el-input v-model="form.episodeTitle" @change="PushUndo('inputEnd')" auth-typecomplete="off" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.Season')}:`" prop="season">
          <el-input v-model="form.season" @input="onlyNumbers('Season')" @change="PushUndo('inputEnd')"  auth-typecomplete="off" maxlength="32" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.Episode1')}:`">
          <el-input v-model="form.episode" @input="onlyNumbers('Episode')" @change="PushUndo('inputEnd')" auth-typecomplete="off" maxlength="32" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.HouseId')" prop="houseId">
          <el-input v-model="form.houseId" readonly auth-typecomplete="off" />
        </el-form-item>
      </el-col>
      <!-- 选择文件或者source -->
      <el-col :span="16">
        <el-form-item :label="$t('lang.referenceMedia')" class="referenceFile" prop="referenceMediaId">
          <div class="ReferenceMedia">
            <div class="PrimarySource">
              <public-multiple-select
                v-if="MediaLiveParams"
                :SelectType="2"
                :configParams="MediaLiveParams"
                :SelectValue="{
                  fileId: form.referenceMediaId,
                  fileName: form.referenceMediaName
                }"
                :otherParam="{placeholder: 'PrimarySource'}"
                @MediaLiveSelectChange="MediaLivePrimaryChange"
                @clearMessage="clearMessage(1)"
              >
              </public-multiple-select>
            </div>
            <div class="Link">
              <i class="iconfont icon-switch"></i>
            </div>
            <div class="SecondarySource">
              <div class="SecondaryHint">{{$t('lang.SecondarySource')}} :</div>
              <!-- <div class="SecondarySelect"> -->
              <public-multiple-select
              v-if="MediaLiveParams"
              :SelectType="2"
              :configParams="MediaLiveParams"
              :SelectValue="{
                fileId: form.secondaryMediaId,
                fileName: form.secondaryMediaName,
              }"
              :otherParam="{placeholder: 'SecondarySource'}"
              @MediaLiveSelectChange="MediaLiveSecondaryChange"
              @clearMessage="clearMessage(2)"
              >
              </public-multiple-select>
              <!-- </div> -->
            </div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.timingList')" class="timingFile" prop="timingId">
          <el-select v-model="form.timingId" @change="changeTimingFile" v-scroll="bindScroll" :popper-append-to-body="false" filterable :filter-method="searchFile">
            <el-option v-for="item in mcpTimingList" :key="item.id" :label="item.name" :value="item.id">
              <span class="timing-item ellipsis" :title="item.name">{{ item.name }}</span>
              <span class="deltete-icon" v-if="form.timingId != item.id" style="float: right;">
                <i class="el-icon-delete" @click.stop="deleteTiming(item)"></i>
              </span>
            </el-option>
          </el-select>
          <upload-file :info="TimingUpload"></upload-file>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.DurationLabel')" required>
          <el-input v-model="programDuration" @input="PushUndo('input')" @change="DurationChange" auth-typecomplete="off" maxlength="32">
            <template slot="append">{{ $t('lang.min') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.Category')}:`">
          <category-select
          v-if="!loading"
          :SelectValue="form.category"
          @fileSelectChange="categoryChange"
          ></category-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.ariDate')">
          <el-date-picker v-model="startTime" :default-value="nowDate" :picker-options="pickerDateBeg" value-format="timestamp" :format="PickerFormat.DateTime" @change="changeHouseId('pushUndo')" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.ThumbnailURL')}:`">
        <upload-thumbnail :SelectValue="form.thumbnail" @ThumbnailSelectChange="ThumbnailSelectChange"></upload-thumbnail>
          <!-- <el-input class="Thumbnails" v-model="form.thumbnail" auth-typecomplete="off" /> -->
        </el-form-item>
      </el-col>
      <el-col :span="8" v-if="FeaturesList.OccasionalOutput">
        <el-form-item :label="`${$t('lang.occasionalOutput')}:`">
          <Output
            v-if="occasionalOutputMessage"
            from="selectList"
            :ProgramItem="ProgramItem"
            :selectedAccount="form.occasionalOutputMessage"
            @AccountSelectInfo="AccountSelectInfo"
          ></Output>
        </el-form-item>
      </el-col>
      <el-col :span="8" v-if="CustomMetadataData.switch">
        <el-form-item :label="`${$t('lang.CustomMetadata')}:`">
          <div class="CustomMetadataEdit">
            <i class="iconfont icon-bianji" @click="CustomMetadataData.edit = true"></i>
            <custom-metadata v-if="CustomMetadataData.edit" :CustomMetadataData="CustomMetadataData.data" :SelectCustomMetadata="form.extraInfos" @SelectCustomMetadataEnd="SelectCustomMetadataEnd"></custom-metadata>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="8">
       <el-form-item :label="`${$t('lang.Folder')}:`">
          <el-select v-model="form.treeId" :popper-append-to-body="false" @focus="getTemplateFolder">
            <el-option v-for="item in templateFolderList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="`${$t('lang.TMSID')}:`">
         <el-input v-model="form.tmSid"  @change="PushUndo('inputEnd')" > </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('lang.programDesc')">
          <div class="desc">
            <el-input type="textarea" v-model="form.description" @input="PushUndo('input')" @change="PushUndo('inputEnd')" maxlength="1024" resize="none">
            </el-input>
            <span class="desNum">{{getLength(form.description)}}</span>
          </div>
        </el-form-item>
      </el-col>
      <el-divider class="line"></el-divider>
      <div class="calculate-info">
        <el-col :span="8">
          <el-form-item :label="$t('lang.TRT')">
            <span>{{ form.mediaTotalTime == 0? '00:00:00' : form.mediaTotalTime * 1000 | DURATION }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8" :class="{'redColor': form.overUnderTime != 0}">
          <el-form-item :label="$t('lang.overTime')">
            <span>{{ !overTimeFlag && form.overUnderTime != 0? '- ' : '' }}{{ form.overUnderTime == 0? '00:00:00' : form.overUnderTime * 1000 | DURATION }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Black">
            <span>{{ form.blackTime == 0? '00:00:00' : form.blackTime * 1000 | DURATION }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item  class="ScteDuration" :label="$t('lang.scteDuration')">
            <el-select v-model="form.scteSpliceDurationDefault" @change="ScteDurationChange" filterable allow-create default-first-option remote>
              <el-option v-for="item in scteDefaultList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <span class="unit">{{$t('lang.seconds')}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('lang.scteInsertion')">
            <span>{{ scteTimes }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('lang.totalTime')">
            <span>{{ form.scteTotalTime == 0? '00:00:00' : form.scteTotalTime * 1000 | DURATION }}</span>
          </el-form-item>
        </el-col>
      </div>
      <!-- 下面子事件 -->
      <el-table :data="tableData" v-loading="loading" current-row-key="1" class="event-table"  ref="table"  @dragover.prevent  element-loading-background="transparent">
        <el-table-column width="45px">
          <template slot-scope="scope">
            <span v-if="scope.row.segmentId == 1" style="margin: 0; ">{{ scope.row.SerialNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120">
          <template slot-scope="scope" v-if="!(((scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block' && scope.row.UnderplayClip == 0)||(scope.row.segmentId == 13 && (scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1)||scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1))">
            <select-menu :disabled="UnderplayClipList[scope.row.blockId] > 1" :data="config.segments" :hideOption="true" :rowKey="scope.$index" :selectVal="scope.row.segmentId" :noTranslate="false" :callback="changeSegment" :placeholder="$t('lang.placeSelect')"></select-menu>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Event')" min-width="120">
          <template slot-scope="scope" v-if="!((scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block' && scope.row.UnderplayClip == 0)">
            <!-- <span v-if="scope.row.segmentId == 1">Reference Media</span> -->
            <select-menu v-if="(scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14)" :disabled="UnderplayClipList[scope.row.blockId] > 1" :data="config.scteType" :rowKey="scope.$index" :selectVal="scope.row.eventOperationType" :noTranslate="false" :callback="changeScteEvent"></select-menu>
            <!-- logo crawl -->
            <select-menu
                v-if="scope.row.segmentId == 13&&scope.row.eventOperationType != 'Flowics'&&scope.row.eventOperationType != 'Singular'"
                :data="config.logoConfig"
                :rowKey="scope.$index"
                :selectVal="scope.row.eventOperationType"
                :noTranslate="true"
                :callback="changeTimeSignal"
            ></select-menu>
            <!-- flowics -->
            <select-menu
                v-if="scope.row.segmentId == 13&&(scope.row.eventOperationType == 'Flowics'&&scope.row.iframeInfoParams.type != 1||scope.row.eventOperationType == 'Singular'&&scope.row.singularInfoParams.type != 1)"
                :data="config.logoConfig"
                :rowKey="scope.$index"
                :selectVal="scope.row.eventOperationType"
                :noTranslate="true"
                :callback="changeTimeSignal"
            ></select-menu>
            <!-- logoTest  HashText-->
            <div class="logoAndHashText"  v-if="scope.row.segmentId == 13&&scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1">{{scope.row.iframeInfoParams.title}}</div>
            <div class="logoAndHashText"  v-if="scope.row.segmentId == 13&&scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1">{{scope.row.singularInfoParams.payloadKey}}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.File')" min-width="140">
          <template slot-scope="scope">
            <span class="referenceMediaName" v-if="scope.row.segmentId == 1">{{ form.referenceMediaName }}</span>
            <div :class="{'UnderplayClipVideo': (scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block'}">
               <public-multiple-select
                  v-if="MediaLiveParams && (scope.row.segmentId == 4 || scope.row.segmentId == 5)"
                  :SelectType="2"
                  :configParams="MediaLiveParams"
                  :SelectValue="{
                    fileId: scope.row.fileId,
                    fileName: scope.row.fileName,
                  }"
                  :otherParam="{placeholder: 'select', hierarchy: tableData.length - scope.$index}"
                  @MediaLiveSelectChange="pitchOnFile => SubeventFileSelect(pitchOnFile, scope.$index)"
                  @clearMessage="SubeventClearMessage(scope.row)"
                >
                </public-multiple-select>
                  <public-multiple-select
                  v-if="MediaParams && (((scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType != 'Scte only') || scope.row.segmentId == 10||scope.row.segmentId==15)"
                  :SelectType="2"
                  :configParams="scope.row.segmentId==15?LiveParams:MediaParams"
                  :SelectValue="{
                    fileId: scope.row.fileId,
                    fileName: scope.row.fileName,
                  }"
                  :SearchTypeList="scope.row.segmentId==15?[true,false,false]:[false, true, true]"
                  :otherParam="{placeholder: 'select', hierarchy: tableData.length - scope.$index}"
                  @MediaLiveSelectChange="pitchOnFile => SubeventFileSelect(pitchOnFile, scope.$index)"
                  @clearMessage="SubeventClearMessage(scope.row)"
                >
                </public-multiple-select>
              <!-- <public-file-select v-if="((scope.row.segmentId == 2 || scope.row.segmentId == 11) && scope.row.eventOperationType != 'Scte only') || scope.row.segmentId == 4 || scope.row.segmentId == 5 || scope.row.segmentId == 10"
                :SelectType="1"
                :searchType='0'
                :SelectValue="{
                  fileId: scope.row.fileId,
                  fileName: scope.row.fileName,
                }"
                @fileSelectChange="
                  (pitchOnFile) => changeFile(pitchOnFile, scope.row,scope.$index)
                "></public-file-select> -->
              <div class="addUnderplayClip">
                <i
                  v-if="(scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block' && scope.row.UnderplayClip != 0"
                  class="iconfont icon-add"
                  @click="addUnderplayClip(scope.row,scope.$index)"></i>
              </div>
            </div>
            <div v-if="scope.row.segmentId == 13 && scope.row.eventOperationType != 'SCTE'" class="Secondary">
              <logo-crawl-select
                v-if="scope.row.eventOperationType=='Crawl'||scope.row.eventOperationType=='Logo'"
                :SelectType="scope.row.eventOperationType == 'Crawl' ? 2 : 1"
                :SelectValue="{
                  fileId: scope.row.fileId,
                  fileName: scope.row.fileName,
                }"
                :FileSelectList="scope.row.eventOperationType == 'Crawl' ? getCrawlList : showThumbList"
                @fileSelectChange="
                  pitchOnFile => LogoCrawlChange(pitchOnFile, scope.row,scope.$index)
                "></logo-crawl-select>
                <el-select
                  v-if="scope.row.eventOperationType=='Singular'&&scope.row.singularInfoParams.type != 1"
                  v-model="scope.row.singularInfoParams.subCompositionName"
                  :placeholder="$t('lang.select')"
                  @change="singularSelect(scope.row,scope.$index)"
                  @focus="getSingularInfo"
                  :popper-append-to-body="false">
                  <el-option
                    v-for="item in singularSelectList"
                    :key="item.subCompositionId"
                    :label="item.subCompositionName"
                    :value="item.subCompositionName"
                    >
                  </el-option>
                </el-select>
                <flowics-select v-if="scope.row.eventOperationType=='Flowics'&&scope.row.iframeInfoParams.type != 1&&SingularMessage.flowicsToken" class="flowicsSelect" :SingularMessage='SingularMessage'  :selectIdParam='scope.row.iframeInfoParams' @FlowicsParamSelect='logoAndHashText=>FlowicsParamSelect(logoAndHashText,scope.row,scope.$index)'></flowics-select>
                <!-- <div class="flowicsAdd" v-if="scope.row.eventOperationType=='Flowics'&&scope.row.iframeInfoParams.type== 0">
                  <i
                    class="iconfont icon-add"
                    @click="addFlowics(scope.row,scope.$index)"></i>
                </div> -->
                <div class="logoAndHashValue" :title="scope.row.iframeInfoParams.value" v-if="scope.row.eventOperationType=='Flowics'&&scope.row.iframeInfoParams.type == 1"><el-input v-model="scope.row.iframeInfoParams.value"></el-input>{{scope.row.iframeInfoParams.value}}</div>
                <div class="logoAndHashValue" :title="scope.row.singularInfoParams.payloadValue" v-if="scope.row.eventOperationType=='Singular'&&scope.row.singularInfoParams.type == 1"><el-input v-model="scope.row.singularInfoParams.payloadValue"></el-input>{{scope.row.singularInfoParams.payloadValue}}</div>
            </div>
            <div v-if="scope.row.segmentId == 13 && scope.row.eventOperationType == 'SCTE'">
              <!-- TimeSignal -->
              <select-menu
                  :data="config.TimeSignalList"
                  :rowKey="scope.$index"
                  :selectVal="scope.row.fileId"
                  :noTranslate="true"
                  :callback="(obj) => {changeTimeSignal(obj, 'TimeSignal')} "
              ></select-menu>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.TimingIn')" min-width="120">
          <template slot-scope="scope">
            <div class="timePicker">
              <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetIn', scope.$index)" v-if="scope.row.segmentId == 13&&(((scope.row.iframeInfoParams&&scope.row.iframeInfoParams.type != 1)||scope.row.eventOperationType!='Flowics')&&((scope.row.singularInfoParams&&scope.row.singularInfoParams.type != 1)||scope.row.eventOperationType!='Singular'))">{{formatSeconds(scope.row.offsetFrom)}}</div>
              <el-time-picker :ref="`SecondaryOffsetIn${scope.$index}`" v-if="!((scope.row.segmentId == 1 && IsHoldEvents)||(scope.row.segmentId == 13&&scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1)||(scope.row.segmentId == 13&&scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1))" v-model="scope.row.timingInTime" :disabled="scope.row.segmentId == 12" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm:ss" :clearable="false" @blur="calculateTime(scope.row, scope.$index, 'start')">
              </el-time-picker>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.TimingOut')" min-width="120">
          <template slot-scope="scope">
            <div class="timePicker">
              <div class="SecondaryOffset" @click="TriggerTimeSelect('SecondaryOffsetOut', scope.$index)" v-if="scope.row.segmentId == 13 && scope.row.eventOperationType != 'SCTE'&&((scope.row.iframeInfoParams&&scope.row.iframeInfoParams.type != 1)||scope.row.eventOperationType!='Flowics')&&((scope.row.singularInfoParams&&scope.row.singularInfoParams.type != 1)||scope.row.eventOperationType!='Singular')">{{formatSeconds(scope.row.offsetTo)}}</div>
              <el-time-picker :ref="`SecondaryOffsetOut${scope.$index}`" v-if="!(scope.row.segmentId == 1 && IsHoldEvents) && !(scope.row.segmentId == 13 && scope.row.eventOperationType == 'SCTE')&&!(scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1)&&!(scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1)" v-model="scope.row.timingOutTime" :disabled="scope.row.segmentId == 12" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm:ss" :clearable="false" @blur="calculateTime(scope.row, scope.$index, 'stop')">
              </el-time-picker>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.AccumulatedTimeing')" min-width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.segmentId != 0 && scope.row.segmentId != 13">{{ scope.row.accumulatedProgramTiming == 0? '00:00:00' : scope.row.accumulatedProgramTiming * 1000 | DURATION }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.operation')" min-width="90">
          <template slot-scope="scope">
            <span :title="$t('lang.insertRowDown')" v-if="scope.row.segmentId != 7 && !((scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block' && scope.row.UnderplayClip == 0)&&!(scope.row.segmentId == 13 &&( scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1||scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1))" class="iconfont i-insert" @click="addRow(scope.$index,scope.row)"><img src="@/assets/img/insert.png"></span>
            <span :class="{'leftM': scope.row.segmentId == 7 || ((scope.row.segmentId == 2 || scope.row.segmentId == 11|| scope.row.segmentId == 14) && scope.row.eventOperationType == 'Underplay Block' && scope.row.UnderplayClip == 0)}" class="iconfont i-delete" @click="deleteRow(scope.row, scope.$index)" v-if="!(scope.row.segmentId == 13 &&( scope.row.eventOperationType == 'Flowics'&& scope.row.iframeInfoParams.type == 1||scope.row.eventOperationType == 'Singular'&& scope.row.singularInfoParams.type == 1))"></span>
          </template>
        </el-table-column>
      </el-table>
      <div class="add-icon" v-if="tableData.length == 0">
        <i class="iconfont i-add" @click="addRow(tableData.length - 1)"></i>
      </div>
      <div class="footer">
         <el-button :disabled="CloneDisabled.Template" v-if="operateType == 'edit' && info.data.TemplateType != 'AmazonS3Templates'" class="delete" @click="deleteTem"  :loading='deleteLoading'>
          {{ $t('lang.delete') }}
        </el-button>
        <el-button class="cancel" @click="cancel">
          {{ $t('lang.cancel') }}
        </el-button>
        <el-button :disabled="CloneDisabled.Template" v-if="operateType == 'edit' && info.data.TemplateType != 'AmazonS3Templates'" class="save" type="primary" @click="saveTem('new')" :loading='saveAsLoading'>
          {{ $t('lang.saveAs') }}
        </el-button>
        <el-button :disabled="CloneDisabled.Template" v-if="info.data.TemplateType != 'AmazonS3Templates'" class="save" type="primary" @click="saveTem" :loading='saveLoading'>
          {{ $t('lang.save') }}
        </el-button>
      </div>
      <over-video-time v-if="OverVideoTime.show" :OverVideoTime="OverVideoTime" @OverTimeSelect="OverTimeSelect" ></over-video-time>
    </el-form>
  </div>
</template>
<script>
import selectMenu from '@/components/common/selectMenu'
// import SelectSearchR from '@/components/common/SelectSearchR';
import Bus from '@/assets/js/vueBus.js'
import { Segments, LogoConfig, ScteType, UnderplayType, SourceConfigParams } from '@/assets/js/temConfig.js'
import { mapState } from 'vuex'
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import LogoCrawlSelect from '@/components/file/LogoCrawlSelect.vue'
import CategorySelect from '@/components/select/CategorySelect.vue'
import Outil from '@/assets/js/utils.js'
import uploadFile from './uploadFile.vue'
import toTips from '@/assets/js/toTipsObj'
import { playoutAnalyze, scheduleAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import UploadThumbnail from '@/components/file/UploadThumbnail.vue'
import Output from '@/views/Workbench/Output.vue'
import UndoAction from '@/assets/js/common/UndoAction.js'
import CustomMetadata from './module/CustomMetadata.vue'
import FlowicsSelect from '../../components/common/FlowicsSelect.vue'
import OverVideoTime from '@/components/common/PopupBox/OverVideoTime.vue'
import DragMethod from '@/assets/js/common/drag'
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {
          tag: 'tem',
          operate: 'add',
          data: {}
        }
      }
    }
  },
  components: {
    selectMenu,
    // SelectSearchR,
    uploadFile,
    LogoCrawlSelect,
    CategorySelect,
    PublicMultipleSelect,
    UploadThumbnail,
    Output,
    CustomMetadata,
    FlowicsSelect,
    OverVideoTime
  },
  data () {
    return {
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        pageNum: 0,
        pageSize: 35,
        condition: '',
        programId: '',
        loadEnd: false
      },
      // source滚动加载
      SourcebindScroll: {
        onScroll: this.getSourceList,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      // timming文件存的文件夹
      FolderObjectKey: '',
      operateType: 'add', // 区分新增或编辑
      operateId: '', // 编辑数据template的id
      oldEventSegments: [], // 更新时做数据对比
      programDuration: 30,
      scteTimes: 0,
      startTime: '',
      overTimeFlag: false,
      receiverId: '',
      nowDate: new Date(),
      form: { // 界面数据
        templateName: '',
        series: '',
        episodeTitle: '',
        episode: 1,
        season: 0,
        houseId: '',
        sourceType: 0,
        referenceMediaId: '',
        referenceMediaName: '',
        mediaTotalTime: 0, // 对应TRT
        templateVideoTotalTime: 0,
        scteTotalTime: 0,
        blackTime: 0,
        addEventSegments: [],
        updateEventSegments: [],
        deleteEventSegments: [],
        timingId: '',
        scteSpliceDurationDefault: 90,
        overUnderTime: 30 * 60,
        description: '',
        secondarySourceType: 0,
        secondaryMediaId: '',
        secondaryMediaName: '',
        category: '',
        thumbnail: '',
        treeId: '',
        tmSid: ''
      },
      config: { // 初始配置文件，TODO:改为从initConfig中获取
        segments: Segments,
        logoConfig: LogoConfig,
        scteType: ScteType,
        underplayType: UnderplayType,
        TimeSignalList: []
      },
      // UnderplayClip scte一组数量
      UnderplayClipList: {},
      fileData: [], // 记录file文件
      // region信息
      RegionInfo: {},
      tableData: [ // 记录event数据
        {
          segmentId: 0,
          eventOperationType: '',
          timingInTime: '00:00:00',
          timingIn: 0,
          timingOutTime: '00:00:00',
          timingOut: 0,
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 0
        }
      ],
      bindScroll: {
        loading: false,
        noMore: false,
        onScroll: this.getNextPage,
        directive: '.el-scrollbar__wrap'
      },
      McpObj: { // 文件滚动加载
        pageNum: 1,
        pageSize: 10,
        condition: ''
      },
      loading: false,
      mcpTimingList: [],
      scteDefaultList: [
        {
          label: '30',
          value: 30
        }, {
          label: '60',
          value: 60
        }, {
          label: '90',
          value: 90
        }, {
          label: '120',
          value: 120
        }
        // , {
        //   label: '150 seconds',
        //   value: 150
        // }, {
        //   label: '180 seconds',
        //   value: 180
        // }, {
        //   label: '210 seconds',
        //   value: 210
        // }, {
        //   label: '240 seconds',
        //   value: 240
        // }
      ],
      TimingUpload: {
        icon: true,
        multiple: false,
        fileType: '.csv,.xml',
        folderName: '/INCOMING',
        type: 3
      },
      rPar: {
        // 获取R列表的参数
        condition: '',
        tpeerId: '',
        bookmardIds: 'all',
        unClassified: true,
        pageNum: 1,
        pageSize: 35
      },
      pickerDateBeg: {
        disabledDate (time) {
          return time.getTime() < new Date().getTime()
        }
      },
      pageMark: '',
      // 时间选择格式
      PickerFormat: {
        Date: 'yyyy-MM-dd',
        Time: 'h:mm:ss A',
        DateTime: 'yyyy-MM-dd h:mm:ss A'
      },
      // 缩略图列表
      showThumbList: [],
      // crawl列表
      getCrawlList: [],
      // mediaLive选择配置
      MediaLiveParams: '',
      // Media选择配置
      MediaParams: '',
      // live选择配置
      LiveParams: '',
      // mediaLive选择所有配置
      AllConfigParams: {},
      allowZeroDuration: false,
      // program信息
      ProgramItem: {},
      // 组件是否加载
      occasionalOutputMessage: false,
      // Features相关控制
      FeaturesList: {
        OccasionalOutput: false,
        HoldEventsRundownTemplate: false
      },
      // 撤回实例
      UndoActionPro: null,
      saveLoading: false,
      saveAsLoading: false,
      deleteLoading: false,
      // 是否HoldEvent模式事件
      IsHoldEvents: false,
      // 自定义数据
      CustomMetadataData: {
        edit: false,
        switch: false,
        data: ''
      },
      // Singular信息
      SingularMessage: {
        flowicsToken: '',
        value: []
      },
      // 文件夹列表
      templateFolderList: [],
      // 超出视频长度提示
      OverVideoTime: {
        show: false,
        type: 'main', // main 主视频, sub 子视频
        actualTime: 0, // 视频实际时间
        setTime: 0, // 设置的时间
        index: null // 子事件的下标
      },
      // 超出视频长度处理
      EventOverLoop: 0,
      // singular  file
      singularSelectList: [],
      numTimes: 0,
      // SCTEUnderplay时间
      segmentScteDurationBehavior: 0,
      //   绑定推拽
      BindDragMethod: '',
      dragIndex: 0
    }
  },
  computed: mapState({
    State: (state) => state,
    listFeatures: (state) => state.playout.listFeatures,
    CloneDisabled: (state) => state.playout.CloneDisabled,
    PitchOnFileList: (state) => state.playout.PitchOnFileList
  }),
  watch: {
    info (val) {
      this.initFormData(val)
    },
    // 监听pgmEnd开关
    listFeatures: {
      handler (val) {
        Object.keys(this.FeaturesList).forEach((key) => {
          if (val.includes(key)) {
            this.FeaturesList[key] = true
          } else {
            this.FeaturesList[key] = false
          }
        })
        if (this.EventMotionSelect != 1) {
          this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
          this.SecondaryHide()
        }
      },
      immediate: true
    },
    'form.templateName': {
      handler (val) {
        this.changeHouseId()
      }
    }
  },
  async  created () {
    Bus.$on('refreshFileList', () => {
      this.getMcpList()
    })
    // 获取时间格式
    this.PickerFormat = Outil.getDateTimePickerFormat()
    await this.getSchedule()
    this.initFormData(this.info)
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    this.getMcpList()
    // 获取source列表
    this.getSourceList()

    const ProgramRMessage = Outil.getProgramReceiver()
    if (ProgramRMessage) {
      this.currentSelectData(ProgramRMessage)
      this.SeetingTimeSignal(ProgramRMessage)
    } else {
      this.$router.push({
        path: '/wb'
      })
    }
    this.GetConfigParams()
    // 获取program信息
    this.ProgramItem = Outil.getProgramReceiver()
    this.getCustomKey()
    this.getExtGfx()
    this.getTemplateFolder()
    Bus.$on('leftListUpdate', this.registerDrag)
    Bus.$on('closeTemplate', (id) => {
      if (this.info.data.id == id) {
        this.cancel()
      }
    })
  },
  mounted () {
    this.getCurrentPage()
    // 获取缩略图
    commonRequest.showThumbList().then((res) => {
      this.showThumbList = res
    })
    commonRequest.getCrawlList().then((res) => {
      this.getCrawlList = res
    })
    // 获取时间超出是否循环
    commonRequest.getEventOverLoop().then((res) => {
      this.EventOverLoop = res
    })
    const UndoParam = {
      MaxStep: 5,
      executeCommand: this.Undo
    }
    this.UndoActionPro = new UndoAction(UndoParam)
    this.UndoActionPro.init()
  },
  methods: {
    // 重新绑定拖拽
    registerDrag () {
      this.$nextTick(() => {
        this.bindingDrag()
      })
    },
    bindingDrag () {
      this.BindDragMethod = new DragMethod()
      this.BindDragMethod.create({
        // 拖到的区域
        dropZones: document.getElementsByClassName('el-table__body-wrapper')[0],
        // 被拖动的元素
        from: [
          document.querySelectorAll('.draggable_box .draggable_item')
        ],
        dropEnd: (e) => {
          const device = JSON.parse(this.BindDragMethod.dragElement.dataset.device)
          if (device.type != 'Video') return
          const dropDocument = e.target.getBoundingClientRect()
          const tableBody = document.getElementsByClassName('el-table__body')[0].getBoundingClientRect()
          const top = dropDocument.top - tableBody.top
          const cellRow = document.getElementsByClassName('el-table__row')[0]
          const cellHeigt = cellRow ? cellRow.getBoundingClientRect().height : tableBody.height
          // 拖拽区域的索引
          const index = Math.floor(top / cellHeigt)
          let reallyIndex, reallyItemObj
          const itemObj = this.tableData[index]
          // 判断是否是多行的子事件
          if (itemObj.blockId) {
            const itemArr = this.tableData.filter(v => v.blockId == itemObj.blockId)
            reallyIndex = itemArr[0].segmentOrder
            reallyItemObj = itemArr[0]
          } else {
            reallyIndex = index
            reallyItemObj = itemObj
          }
          // 是否为批量添加
          if (this.PitchOnFileList[device.id]) {
            Object.values(this.PitchOnFileList).forEach((item, i) => {
              this.addRow(reallyIndex + i, reallyItemObj)
              this.changeSegment({ index: this.dragIndex + 1, val: 10 })
              this.SubeventFileSelect(item, this.dragIndex + 1)
            })
          } else {
            this.addRow(reallyIndex, reallyItemObj)
            this.changeSegment({ index: this.dragIndex + 1, val: 10 })
            this.SubeventFileSelect(device, this.dragIndex + 1)
          }
        }
      })
    },
    getLength (des) {
      return Outil.getByteLength(des)
    },
    // 接收撤回消息
    Undo (data) {
      let item = ''
      this.occasionalOutputMessage = false
      Object.keys(data).forEach((key) => {
        try {
          item = JSON.parse(data[key])
        } catch (error) {}
        if (typeof item == 'object') {
          this._data[key] = item
        } else {
          this._data[key] = data[key]
        }
      })
      this.$nextTick(() => {
        this.occasionalOutputMessage = true
      })
    },
    // 发送行为消息
    PushUndo (type) {
      const PreviousAction = {}
      const key = (type == 'input' || type == 'inputEnd') ? type : ''
      PreviousAction.operateId = this.operateId
      PreviousAction.programDuration = this.programDuration
      PreviousAction.startTime = this.startTime
      PreviousAction.scteTimes = this.scteTimes
      PreviousAction.oldEventSegments = JSON.stringify(this.oldEventSegments)
      PreviousAction.form = JSON.stringify(this.form)
      PreviousAction.tableData = JSON.stringify(this.tableData)
      PreviousAction.UnderplayClipList = JSON.stringify(this.UnderplayClipList)
      if (type == 'clearUndo') {
        this.UndoActionPro.clearUndo(PreviousAction)
      } else {
        this.UndoActionPro.pushUndo(PreviousAction, key)
      }
    },
    // 获取文件夹列表
    getTemplateFolder () {
      this.axios.post(Outil.getUrl('/eventTemplate/getTemplateFolders'), {
        programId: this.$BehaviorSyns.getProgramId()
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.templateFolderList = res.data.result
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取选择的推流账号
    AccountSelectInfo (val) {
      this.form.occasionalOutputMessage = JSON.parse(JSON.stringify(val))
      // 推送操作
      this.PushUndo()
    },
    // 是否允许duration为0
    async getSchedule () {
      await this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/schedule'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.allowZeroDuration = result.allowZeroDuration
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 缩略图赋值
    ThumbnailSelectChange (key) {
      this.form.thumbnail = key
      // 推送操作
      this.PushUndo()
    },
    // 标签选择
    categoryChange (value) {
      this.form.category = value
      // 推送操作
      this.PushUndo()
    },
    // 自定义数据选择
    SelectCustomMetadataEnd (data) {
      if (data) {
        console.log(data, 'lll')
        this.CustomMetadataData.edit = false
        this.form.extraInfos = data
      } else {
        this.CustomMetadataData.edit = false
      }
    },
    // 获取自定义key
    getCustomKey () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/templates'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.CustomMetadataData.switch = !!result.enableEpgExtra
            this.CustomMetadataData.data = result.epgExtraKey
            if (this.info.type == 'add' && result.defaultSeason != null && result.defaultSeason != undefined) {
              this.form.season = result.defaultSeason
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    // Secondary类型功能显示隐藏
    SecondaryHide () {
      const List = JSON.parse(JSON.stringify(this.config.segments))
      if (this.IsHoldEvents) {
        List[8].isShow = false
      } else {
        List[8].isShow = true
      }
      this.config.segments = List
    },
    // 设置TimeSignal选项的
    SeetingTimeSignal (ProgramRMessage) {
      const List = JSON.parse(JSON.stringify(this.config.segments))
      if (ProgramRMessage.scteType) {
        List[2].isShow = false
      } else {
        List[3].isShow = false
      }
      this.config.segments = List
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/scte'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.segmentScteDurationBehavior = result.segmentScteDurationBehavior ? 1 : 0
            Object.keys(result.timeSignalScte).forEach(key => {
              this.config.TimeSignalList.push({
                value: key,
                label: key,
                key: result.timeSignalScte[key]
              })
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 删除timing文件
    deleteTiming (item) {
      const Url = '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/delete'
      const params = {
        fileId: item.id
      }
      this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success('delete success')
          this.getMcpList()
        } else {
          this.$message.info(this.$t('lang.fileUsed'))
        }
      }).catch(() => {})
    },
    // 存rid
    currentSelectData (item, index) {
      // 接收R数据
      // this.chooseRIndex = index;
      this.receiverId = JSON.parse(JSON.stringify(item)).peerId
    },
    // 更新模板
    editTem () {
      this.sortSegments()
      const params = this.objDeepCopy(this.form)
      params.id = this.operateId
      params.occasionalOutputMessage = JSON.stringify(params.occasionalOutputMessage)
      if (params.overUnderTime) {
        // true是超出false没超出
        if (!this.overTimeFlag) {
          params.overUnderTime = -params.overUnderTime
          params.templateVideoTotalTime = this.programDuration * 60
        }
      }
      this.saveLoading = true
      this.axios.post(Outil.getUrl('/eventTemplate/checkProgramTemplateIsUsing'), {
        id: params.id
      }).then((res) => {
        let Hint = ''
        this.saveLoading = false
        if (res.data.errorCode == '0x0') {
          Hint = 'UpdateTemplate'
        } else if (res.data.errorCode == '81002911') {
          Hint = 'TemplateUpdateLiveEvent'
        } else if (res.data.errorCode == '81002912') {
          Hint = 'TemplateUpdateEvent'
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
        if (Hint) {
          this.$confirm(this.$t(`lang.${Hint}`), '', {
            confirmButtonText: this.$t('lang.Confirm'),
            cancelButtonText: this.$t('lang.close'),
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.UpdateTemplate(params)
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    // 更新模板
    UpdateTemplate (params) {
      this.saveLoading = true
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/update', params).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('lang.updateSuccess'))
          Bus.$emit('refreshTemList', 'tem')
          this.$emit('closeProgramTemplate')
          this.InformEventUpdate()
        } else {
          this.saveLoading = false
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 新增模板
    addTem (tag) {
      this.dealOrder()
      const params = this.objDeepCopy(this.form)
      params.addEventSegments = this.objDeepCopy(this.tableData)
      params.occasionalOutputMessage = JSON.stringify(params.occasionalOutputMessage)
      if (params.overUnderTime) {
        // true是超出false没超出
        if (!this.overTimeFlag) {
          params.overUnderTime = -params.overUnderTime
          params.templateVideoTotalTime = this.programDuration * 60
        }
      }
      params.holdEventRundownTemplate = this.IsHoldEvents ? 1 : 0
      if (tag) {
        this.saveAsLoading = true
      } else {
        this.saveLoading = true
      }

      this.axios.post(Outil.getUrl('/eventTemplate/add'), params).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.operateType = 'edit'
          this.operateId = res.data.result.id
          this.form.addEventSegments = []
          this.form.updateEventSegments = []
          this.form.deleteEventSegments = []
          this.getTemInfoById(this.operateId, 'tem')
          this.$message.success(this.$t('lang.addSuccess'))
          Bus.$emit('refreshTemList', 'tem')
          this.$emit('closeProgramTemplate')
          this.InformEventUpdate()
          this.saveLoading = false
          this.saveAsLoading = false
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          this.saveLoading = false
          this.saveAsLoading = false
        }
      }).catch(() => {})
    },
    // 新增template
    saveTem (tag) {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerProgramTemplateHeaderAddSave', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutProgramTemplateHeaderAddSave', '/pop')
      }
      // 保存时form表单空验证
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // 当用户选择了Air Date and Time之后需要获取R相关信息并添加参数传给后台
          if (this.startTime != '' && this.startTime != null) {
            this.form.receiverId = this.receiverId
            this.form.startTime = this.startTime
          } else {
            // 清空时间时，会不清除历史的时间
            this.form.startTime = 0
          }
          if (this.form.templateName.indexOf('/') >= 0) {
            this.$message.error(`/ ${this.$t('lang.notAllowedName')}`)
            return
          }
          // 通过判断有没有开始时间来更新event
          if (this.operateType == 'add' || this.operateType == 'edit' && tag && tag == 'new') {
            this.addTem(tag)
          } else {
            this.editTem()
          }
        } else {
          return false
        }
      })
    },
    // 通知event更新
    InformEventUpdate () {
      // 通过websocket通知更新event
      this.$BehaviorSyns.SendBehavior('EventListChange', 1)
    },
    // 删除template
    deleteTem () {
      this.$confirm(this.$t('lang.deleteMediaList'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/delete'
        const params = {
          ids: [this.operateId]
        }
        this.deleteLoading = true
        this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.deleteSuccess'))
            this.$emit('closeProgramTemplate')
            Bus.$emit('refreshTemList', 'tem')
            this.deleteLoading = false
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            this.deleteLoading = false
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 根据templateId拿template信息/根据fileId拿event信息
    getTemInfoById (id, tag, TemplateType) {
      if (this.loading) {
        this.$message.info(this.$t('lang.frequentOperation'))
        return
      }
      this.loading = true
      this.tableData = []
      let params = {}
      let url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/getById'
      // 外部s3模板
      if (TemplateType == 'AmazonS3Templates') {
        url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/getExternalById'
        params = {
          id,
          programId: this.$BehaviorSyns.getProgramId()
        }
      } else {
        url = tag && tag == 'tem' ? '/gatewayPlayoutUrl/tvu-playout/eventTemplate/getById' : '/gatewayPlayoutUrl/tvu-playout/eventTemplate/resolveSegments'
        params = tag && tag == 'tem' ? { id } : {
          fileId: id,
          defaultScteDuration: this.form.scteSpliceDurationDefault
        }
      }
      this.axios.post(url, params, {
        contentType: 'application/json;charset=UTF-8'
      }).then((res) => {
        this.loading = false
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          let eventArr = []
          console.log(tag)
          if (tag && tag == 'tem') {
            this.form.templateName = data.templateName
            this.form.episode = data.episode
            this.form.houseId = data.houseId
            this.form.sourceType = data.sourceType
            this.form.referenceMediaId = data.referenceMediaId
            this.form.referenceMediaName = data.referenceMediaName
            this.form.mediaTotalTime = data.mediaTotalTime
            this.form.templateVideoTotalTime = data.templateVideoTotalTime
            this.form.blackTime = data.blackTime
            this.form.scteSpliceDurationDefault = data.scteSpliceDurationDefault == '0' ? '90' : data.scteSpliceDurationDefault
            this.form.overUnderTime = data.overUnderTime
            this.scteTimes = data.breaks
            this.form.thumbnail = data.thumbnail
            this.form.category = data.category
            this.form.scteTotalTime = data.breakTotalTime
            this.form.secondarySourceType = data.secondarySourceType
            this.form.secondaryMediaId = data.secondaryMediaId
            this.form.secondaryMediaName = data.secondaryMediaName
            this.form.occasionalOutputMessage = data.occasionalOutputMessage ? JSON.parse(data.occasionalOutputMessage) : []
            this.occasionalOutputMessage = true
            this.form.holdEventRundownTemplate = data.holdEventRundownTemplate
            this.form.extraInfos = data.extraInfos
            this.form.eventMediaDuration = data.eventMediaDuration
            this.form.treeId = data.treeId
            this.form.season = data.season
            this.form.series = data.series
            this.form.episodeTitle = data.episodeTitle
            this.form.tmSid = data.tmSid
            this.startTime = data.startTime == 0 ? '' : data.startTime
            this.oldEventSegments = tag && tag == 'tem' && data.eventSegments ? this.objDeepCopy(data.eventSegments) : [] // 只有选中template时才记录初始的event
            if (data.overUnderTime >= 0) {
              this.programDuration = Math.floor((data.templateVideoTotalTime - data.overUnderTime) / 60)
            } else {
              this.programDuration = Math.floor((data.templateVideoTotalTime) / 60)
            }
            // 判断编辑还是创建 赋予是否为Hold模式
            if (this.info.type == 'edit') {
              this.IsHoldEvents = this.form.holdEventRundownTemplate == 1
            } else {
              this.IsHoldEvents = this.FeaturesList.HoldEventsRundownTemplate
            }
            this.SecondaryHide()
          } else {
            // 选择timing文件匹配到视频
            this.MatchFile(res.data.result)
          }
          this.form.description = data.description || ''
          // if (tag && tag == 'mcp') {
          eventArr = data.eventSegments ? this.objDeepCopy(data.eventSegments) : []
          // }
          if (eventArr.length > 0) {
            // if (row.segmentId == 1 && tag == 'start') {
            //     const referenceMediaBefore = (this.tableData.slice(0, rowIndex + 1)).filter(item => item.segmentId == 1)
            //     itemObj.black = itemObj.timingIn - referenceMediaBefore[referenceMediaBefore.length - 2].timingOut
            // }
            eventArr.forEach((itm) => {
              if (!itm.iframeInfoParams) {
                itm.iframeInfoParams = {
                  id: '',
                  // name: 'Logo',
                  // state: 'in',
                  type: '',
                  title: '',
                  value: '',
                  sceneId: '',
                  regionId: ''
                }
              }
              if (itm.segmentId == '2' && !itm.eventOperationType) itm.eventOperationType = 'Scte only'
              if ((itm.segmentId == 2 || itm.segmentId == 11 || itm.segmentId == 14) && itm.eventOperationType == 'Underplay Block') {
                if (this.UnderplayClipList[itm.blockId]) {
                  itm.UnderplayClip = 0
                  itm.blockId && (this.UnderplayClipList[itm.blockId] += 1)
                } else {
                  itm.UnderplayClip = 1
                  itm.blockId && (this.UnderplayClipList[itm.blockId] = 1)
                }
              } else if (itm.segmentId == 13 && (itm.eventOperationType == 'Flowics' || itm.eventOperationType == 'Singular')) {
                if (this.UnderplayClipList[itm.blockId]) {
                  itm.blockId && (this.UnderplayClipList[itm.blockId] += 1)
                } else {
                  itm.blockId && (this.UnderplayClipList[itm.blockId] = 1)
                }
              }
            })
            this.tableData = this.objDeepCopy(eventArr)
            this.changeTableData()
          }
          if (tag && tag == 'mcp') {
            this.TimeReferenceMedia(this.form.mediaTotalTime)
          }
          if (tag == 'tem') {
            // 推送操作
            this.PushUndo()
          } else {
            // 推送操作
            this.PushUndo()
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    changeTimingFile (id) {
      this.getTemInfoById(id, 'mcp')
    },
    // 子事件文件选择
    SubeventFileSelect (pitchOnFile, rowIndex) {
      // 判断是media还是Live Source
      const FileMessage = pitchOnFile
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        if (pitchOnFile.peerId) {
          FileMessage.sourceId = pitchOnFile.peerId
        }
        FileMessage.videoTimes = 30 * 60
        FileMessage.id = FileMessage.sourceId
        this.changeFile(pitchOnFile, 1, rowIndex)
      } else {
        this.changeFile(pitchOnFile, 2, rowIndex)
      }
    },
    // 子事件文件信息清除
    SubeventClearMessage (item) {
      item.sourceId = ''
      item.fileType = ''
      item.fileName = ''
      item.fileId = ''
      item.sonEventMediaDuration = 0
      // 推送操作
      this.PushUndo()
    },
    // 切换文件
    changeFile (pitchOnFile, type, rowIndex) {
      const itemObj = this.tableData[rowIndex]
      pitchOnFile.videoTimes = Math.floor(pitchOnFile.videoTimes)
      itemObj.timingIn = 0
      // 存一下视频的duration
      itemObj.sonEventMediaDuration = type == 2 ? pitchOnFile.videoTimes : 0
      if (itemObj.segmentId == 2 || itemObj.segmentId == 11 || itemObj.segmentId == 14) {
        itemObj.duration = this.form.scteSpliceDurationDefault
        // 是否使用视频时间
        if (this.segmentScteDurationBehavior) {
          itemObj.duration = pitchOnFile.videoTimes
        }
      } else {
        itemObj.duration = pitchOnFile.videoTimes
      }
      itemObj.timingOut = itemObj.duration
      itemObj.fileName = pitchOnFile.name
      itemObj.sourceId = pitchOnFile.sourceId
      itemObj.fileId = pitchOnFile.id
      this.tableData.splice(rowIndex, 1, itemObj)
      this.changeTableData()
      // 推送操作
      this.PushUndo()
    },
    // logo，crawl选择
    LogoCrawlChange (pitchOnFile, row, rowIndex) {
      const itemObj = this.tableData[rowIndex]
      itemObj.fileId = pitchOnFile.fileId
      itemObj.fileName = pitchOnFile.name
      this.tableData.splice(rowIndex, 1, itemObj)
      // 推送操作
      this.PushUndo()
    },
    // 修改HouseId
    changeHouseId (key) {
      if (this.startTime != '' && this.startTime != null && this.form.referenceMediaId != '') {
        if (this.form.templateName != '') {
          const setTime = Outil.getDateTime(new Date(this.startTime))
          this.form.houseId = `${this.form.templateName.substring(0, 4)}-${setTime.month}${setTime.day}${setTime.year}-${setTime.hour}${setTime.min}${setTime.s}`
        } else {
          this.form.houseId = ''
        }
      } else {
        this.form.houseId = ''
      }
      // 推送操作
      if (key == 'pushUndo') this.PushUndo()
    },
    // timing文件更新主视频
    MatchFile (fileMessage) {
      if (fileMessage.referenceMediaId) {
        const item = {
          id: fileMessage.referenceMediaId,
          name: fileMessage.referenceMediaName,
          videoTimes: fileMessage.mediaTotalTime
        }
        this.changeReferenceFile(item)
      }
    },
    // 更改类型
    sourceTypeChange () {
      this.form.referenceMediaId = ''
      this.form.referenceMediaName = ''
    },
    // 清楚主源备用源
    clearMessage (type) {
      // 主源
      if (type == 1) {
        this.form.referenceMediaId = ''
        this.form.referenceMediaName = ''
        this.form.eventMediaDuration = 0
      } else {
        this.form.secondaryMediaName = ''
        this.form.secondaryMediaId = ''
      }
      // 推送操作
      this.PushUndo()
    },
    // 第一视频选择
    MediaLivePrimaryChange (pitchOnFile) {
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        if (pitchOnFile.peerId) {
          pitchOnFile.sourceId = pitchOnFile.peerId
        }
        this.SelectSource(pitchOnFile)
      } else {
        this.changeReferenceFile(pitchOnFile)
      }
      // 推送操作
      this.PushUndo()
    },
    // 备用视频选择
    MediaLiveSecondaryChange (pitchOnFile) {
      if (pitchOnFile.peerId) {
        pitchOnFile.sourceId = pitchOnFile.peerId
      }
      // 判断是media还是Live Source
      if (pitchOnFile.Select == 'Live' || (pitchOnFile.Select == 'search' && pitchOnFile.category == 1)) {
        this.form.secondaryMediaName = pitchOnFile.name
        this.form.secondaryMediaId = pitchOnFile.sourceId
        this.form.secondarySourceType = 1
      } else {
        this.form.secondaryMediaName = pitchOnFile.name
        this.form.secondaryMediaId = pitchOnFile.id
        this.form.secondarySourceType = 0
      }
      // 推送操作
      this.PushUndo()
    },
    // 更改主视频
    changeReferenceFile (item) {
      this.form.sourceType = 0
      this.form.referenceMediaId = item.id
      this.form.referenceMediaName = item.name
      // this.form.templateName = this.form.templateName == ''? item.name :  this.form.referenceMediaName.split('.mp4')[0]
      this.form.mediaTotalTime = Math.floor(item.videoTimes ? item.videoTimes : 0)
      this.form.templateName = this.form.templateName == '' ? this.form.referenceMediaName.split('.mp4')[0] : this.form.templateName
      // 存一下视频时长
      this.form.eventMediaDuration = this.form.mediaTotalTime
      this.changeHouseId()
      this.TimeReferenceMedia(this.form.mediaTotalTime)
    },
    // 选择source
    SelectSource (FileMessage) {
      this.form.sourceType = 1
      this.form.referenceMediaId = FileMessage.sourceId
      this.form.referenceMediaName = FileMessage.name
      this.form.mediaTotalTime = this.programDuration * 60
      // 视频时长至0
      this.form.eventMediaDuration = 0
      // this.form.templateName = this.form.templateName == '' ? this.form.referenceMediaName : this.form.templateName
      this.changeHouseId()
      this.countReferenceMedia(this.form.mediaTotalTime)
    },
    // 计算子事件Reference Media时间
    countReferenceMedia (sourceDuration) {
      // media总时长
      let MediaTotalDuration = 0
      this.tableData.forEach((item) => {
        if (item.segmentId === 1) {
          const eventDuration = item.timingOut - item.timingIn
          MediaTotalDuration += eventDuration
        }
      })
      // 类型为Media时
      if (!this.form.sourceType && this.form.eventMediaDuration && MediaTotalDuration > this.form.eventMediaDuration) {
        this.MainVideoOvertime(this.form.eventMediaDuration)
        // this.TimeReferenceMedia(this.form.eventMediaDuration)
        // this.$message.info(this.$t('lang.mediaTimeOverstep'))
      } else if (this.form.sourceType && MediaTotalDuration == 0 && sourceDuration) {
        this.TimeReferenceMedia(sourceDuration)
      }
    },
    // 主视频选择时间超出视频时间
    MainVideoOvertime (actualTime) {
      if (this.EventOverLoop === 2) {
        if (actualTime) this.TimeReferenceMedia(actualTime)
      } else if (this.EventOverLoop != 1) {
        this.OverVideoTime = {
          show: true,
          type: 'main',
          actualTime
        }
      }
      // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
      //   confirmButtonText: this.$t('lang.Confirm'),
      //   cancelButtonText: this.$t('lang.cancel'),
      //   dangerouslyUseHTMLString: true
      // }).then(() => {}).catch(() => {
      //   if (actualTime) this.TimeReferenceMedia(actualTime)
      // })
    },
    // 其他视频选择时间超出视频时间
    OtherVideoOvertime (itemObj, index) {
      const MediaDuration = itemObj.timingOut - itemObj.timingIn
      if (itemObj.sonEventMediaDuration && MediaDuration > itemObj.sonEventMediaDuration) {
        if (this.EventOverLoop === 2) {
          itemObj.timingOut = itemObj.sonEventMediaDuration + itemObj.timingIn
          // 子事件时间格式化
          this.changeTableData()
        } else if (this.EventOverLoop != 1) {
          this.OverVideoTime = {
            show: true,
            type: 'sub',
            index
          }
        }
        // this.$confirm(this.$t('lang.OvertimeLoop'), '', {
        //   confirmButtonText: this.$t('lang.Confirm'),
        //   cancelButtonText: this.$t('lang.cancel'),
        //   dangerouslyUseHTMLString: true
        // }).then(() => {}).catch(() => {
        //   itemObj.timingOut = itemObj.sonEventMediaDuration + itemObj.timingIn
        //   // 子事件时间格式化
        //   this.changeTableData()
        // })
      }
    },
    // 超出时间选择结果
    OverTimeSelect (OverTime) {
      if (this.OverVideoTime.type === 'main') {
        // 选择不超出
        if (OverTime.ExtendTime === 2 && this.OverVideoTime.actualTime) {
          this.TimeReferenceMedia(this.OverVideoTime.actualTime)
        }
      } else if (this.OverVideoTime.type === 'sub') {
        if (OverTime.ExtendTime === 2 && this.OverVideoTime.index != null) {
          const itemObj = this.tableData[this.OverVideoTime.index]
          itemObj.timingOut = itemObj.sonEventMediaDuration + itemObj.timingIn
          // 子事件时间格式化
          this.changeTableData()
        }
      }
      if (OverTime.NoAgainAsk) {
        this.EventOverLoop = OverTime.ExtendTime
        commonRequest.setEventOverLoop(this.ProgramItem.ProgramId, OverTime.ExtendTime)
      }
    },
    // 根据时间增加删除Reference Media
    TimeReferenceMedia (videoTime) {
      if (this.IsHoldEvents) {
        return
      }
      const obj = {
        segmentId: 1,
        eventOperationType: '',
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: 0
      }
      const EventLength = this.tableData.length
      if (EventLength > 0) {
        let timeLeft = videoTime
        let LastMedia = null
        for (let i = 0; i < EventLength; i++) {
          const item = this.tableData[i]
          if (!item || item.segmentId !== 1) {
            continue
          }
          const eventDuration = item.timingOut - item.timingIn
          if (timeLeft == 0) {
            this.tableData.splice(i, 1)
            i--
          } else if (eventDuration >= timeLeft) {
            item.timingOut = item.timingIn + timeLeft
            timeLeft = 0
          } else if (eventDuration < timeLeft) {
            timeLeft -= eventDuration
          }
          LastMedia = item
        }
        if (timeLeft > 0) {
          if (LastMedia) {
            LastMedia.timingOut = LastMedia.timingOut + timeLeft
          } else if (this.tableData[EventLength - 1].segmentId == 7) {
            obj.segmentOrder = EventLength - 1
            obj.timingOut = obj.timingIn + timeLeft
            this.tableData.splice(EventLength - 1, 0, obj)
          } else {
            obj.segmentOrder = EventLength
            obj.timingOut = obj.timingIn + timeLeft
            this.tableData.push(obj)
          }
        }
      } else {
        obj.timingOut = obj.timingIn + videoTime
        this.tableData.push(obj)
      }
      this.changeTableData()
    },
    // 处理排序
    dealOrder () {
      this.tableData = this.tableData.map((item, i) => {
        return { ...item, segmentOrder: i }
      })
    },
    // 更新template提交之前数据处理
    sortSegments () {
      this.dealOrder()
      const newArr = [...new Set([...this.oldEventSegments, ...this.tableData])]
      const arr1 = this.objDeepCopy(this.tableData)
      const arr2 = this.objDeepCopy(this.oldEventSegments)
      const deleteEventSegments = [...newArr].filter((x) => [...arr1].every((y) => y.id !== x.id))
      const addEventSegments = [...newArr].filter((x) => [...arr2].every((y) => y.id !== x.id))
      const updateEventSegments = arr1.filter((x) => arr2.filter((y) => y.id == x.id))
      this.form.updateEventSegments = []
      updateEventSegments.forEach((item) => {
        if (item.id) {
          this.form.updateEventSegments.push(item)
        }
      })
      this.form.deleteEventSegments = []
      deleteEventSegments.forEach((item) => {
        this.form.deleteEventSegments.push(item.id)
      })
      this.form.addEventSegments = []
      addEventSegments.forEach((item) => {
        if (item.segmentId && item.segmentId != null) {
          this.form.addEventSegments.push(item)
        }
      })
    },
    // 时间修改
    calculateTime (row, rowIndex, tag) {
      /** 修改时间时，如果开始和结束时间都有，
       * 如果修改开始时间，结束时间小于当前时间时自动修改为开始时间往后添加10s
       * 如果修改结束时间，开始时间大于当前时间时自动修改为结束时间往前减少10s，最小为00:00:00
       * 每次修改时同步修改duration，后面可以直接判断duration
       *
       * 如果修改的是Reference Meida的开始和结束时间，则需要同步修改前后Reference Media的时间，这里同步修改blackTime
       * 所有修改必须保证每一条数据开始和结束时间准确（Reference Meida）
      */
      console.log(row, rowIndex, tag)
      const itemObj = this.tableData[rowIndex]
      itemObj.timingIn = this.$options.filters.GETDURATIONNUM('', `2021-1-1 ${row.timingInTime}`)
      itemObj.timingOut = this.$options.filters.GETDURATIONNUM('', `2021-1-1 ${row.timingOutTime}`)
      itemObj.duration = itemObj.timingOut - itemObj.timingIn
      if (tag == 'start') {
        if (itemObj.duration < 0) {
          itemObj.timingOut = itemObj.timingIn
        }
        // program Start 自动计算结束时间
        if (rowIndex > 0 && this.tableData[rowIndex - 1].segmentId == 6) {
          const startObj = this.tableData[rowIndex - 1]
          startObj.timingOut = itemObj.timingIn
          startObj.duration = startObj.timingOut - startObj.timingIn
          this.tableData.splice(rowIndex - 1, 1, startObj)
        }
      } else if (itemObj.timingIn > itemObj.timingOut) {
        itemObj.timingIn = itemObj.timingOut
      }
      if (row.segmentId == 1 && tag == 'start') {
        const referenceMediaBefore = (this.tableData.slice(0, rowIndex + 1)).filter((item) => item.segmentId == 1)
        if (referenceMediaBefore.length > 1) {
          itemObj.black = itemObj.timingIn - referenceMediaBefore[referenceMediaBefore.length - 2].timingOut
        } else {
          itemObj.black = 1
        }
      }
      if (row.segmentId == 13) {
        this.countOffset(itemObj)
      }
      this.tableData.splice(rowIndex, 1, itemObj)
      if (itemObj.segmentId == 1) {
        this.countReferenceMedia()
      } else if (itemObj.segmentId == 4 || itemObj.segmentId == 5 || itemObj.segmentId == 10 || ((itemObj.segmentId == 2 || itemObj.segmentId == 11 || itemObj.segmentId == 14) && itemObj.eventOperationType != 'Scte only')) {
        this.OtherVideoOvertime(itemObj, rowIndex)
        // const MediaDuration = itemObj.timingOut - itemObj.timingIn
        // if (itemObj.sonEventMediaDuration && MediaDuration > itemObj.sonEventMediaDuration) {
        //   itemObj.timingOut = itemObj.sonEventMediaDuration + itemObj.timingIn
        //   this.$message.info(this.$t('lang.mediaTimeOverstep'))
        // }
      }
      this.changeTableData()
      // 推送操作
      this.PushUndo()
    },
    // 触发时间选择
    TriggerTimeSelect (type, index) {
      if (type == 'SecondaryOffsetIn') {
        this.$refs[`SecondaryOffsetIn${index}`].focus()
      } else if (type == 'SecondaryOffsetOut') {
        this.$refs[`SecondaryOffsetOut${index}`].focus()
      }
    },
    // 计算偏移量
    countOffset (itemObj) {
      let parent = {}
      let IsHint = false
      this.tableData.forEach((item, index) => {
        if (item.segmentId != 13) {
          // Underplay Block时间为一组时间
          if (item.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && item.blockId == parent.blockId) {
            parent.timingOut = parent.timingOut + item.duration
          } else {
            parent = JSON.parse(JSON.stringify(item))
          }
        } else {
          if (!(parent.timingIn <= item.timingIn && item.timingIn <= parent.timingOut)) {
            item.timingIn = parent.timingIn
            if (!IsHint && parent.timingOut) {
              IsHint = true
              this.$message.info(this.$t('lang.SecondaryStartTime'))
            }
          }
          if (!(parent.timingIn <= item.timingOut && item.timingOut <= parent.timingOut)) {
            item.timingOut = parent.timingOut
          }
          item.offsetFrom = item.timingIn - parent.timingIn
          item.offsetTo = item.timingOut - parent.timingOut
        }
      })
      if (itemObj && itemObj.segmentId == 13 && itemObj.eventOperationType == 'Flowics') {
        this.tableData = this.tableData.map((item, index) => {
          if (item.blockId == itemObj.blockId && item.iframeInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == itemObj.blockId && item.iframeInfoParams.type == 1) {
            return {
              ...item,
              timingInTime: this.mainFlowicsParams.timingInTime,
              timingOutTime: this.mainFlowicsParams.timingOutTime,
              offsetFrom: this.mainFlowicsParams.offsetFrom,
              offsetTo: this.mainFlowicsParams.offsetTo,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      } else if (itemObj && itemObj.segmentId == 13 && itemObj.eventOperationType == 'Singular') {
        this.tableData = this.tableData.map((item, index) => {
          if (item.blockId == itemObj.blockId && item.singularInfoParams.type != 1) {
            this.mainFlowicsParams = item
            return item
          } else if (item.blockId == itemObj.blockId && item.singularInfoParams.type == 1) {
            return {
              ...item,
              timingInTime: this.mainFlowicsParams.timingInTime,
              timingOutTime: this.mainFlowicsParams.timingOutTime,
              offsetFrom: this.mainFlowicsParams.offsetFrom,
              offsetTo: this.mainFlowicsParams.offsetTo,
              timingIn: this.mainFlowicsParams.timingIn,
              timingOut: this.mainFlowicsParams.timingOut
            }
          } else {
            return item
          }
        })
      }
    },
    // 偏移量时间转换
    formatSeconds (time) {
      return Outil.formatSecondsChange(time)
    },
    // 获取objectkey
    async getObjectKey (userId) {
      const param = {
        directory: 'INCOMING',
        userId,
        bucket: this.RegionInfo.bucket
      }
      await this.axios
        .post('/file/get-user-bucket-dir', param, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.FolderObjectKey = res.data.result.objectKey
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 获取timing文件
    async getMcpList () {
      if (!this.FolderObjectKey) {
        const userId = Outil.getProgramReceiver('ownerUserId')
        await this.getObjectKey(userId)
      }
      const params = {
        isDirectory: false,
        suffixList: ['csv', 'xml'],
        region: this.RegionInfo.region,
        service: this.RegionInfo.ServerName,
        bucketId: this.RegionInfo.bucketId,
        type: 3,
        objectKeyLike: this.FolderObjectKey,
        nameLike: this.McpObj.condition,
        pageIndex: this.McpObj.pageNum,
        pageSize: this.McpObj.pageSize
      }
      this.axios.post('/file/query', params, { requestBase: 'GATEWAY' }).then((res) => {
        if (res.data.errorCode === '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.mcpTimingList = this.mcpTimingList.concat(res.data.result.records)
          } else {
            this.mcpTimingList = res.data.result.records
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 搜索timming文件列表
    searchFile (value) {
      this.McpObj.pageNum = 0
      this.McpObj.condition = value
      this.getMcpList()
    },
    // Flowics联级选择后触发
    FlowicsParamSelect (data, item, index) {
      const controls = data.data.controls
      const textArr = Object.values(controls)
      item.iframeInfoParams = {
        id: data.value[2],
        // name: 'Logo',
        state: 'in',
        type: textArr.length == 0 ? 2 : 0,
        title: '',
        value: '',
        sceneId: data.value[0],
        regionId: data.value[1]
      }
      // 先去掉logoText和hashText 再添加
      this.tableData = this.tableData.filter(v => {
        return (v.blockId != item.blockId) || (v.iframeInfoParams.type == 0) || (v.iframeInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      let obj
      textArr.forEach((v, i) => {
        obj = {
          segmentId: item.segmentId,
          eventOperationType: item.eventOperationType,
          blockId: item.blockId,
          flowics: 0,
          fileId: '',
          timingIn: 0,
          timingInTime: '00:00:00',
          timingOut: 0,
          timingOutTime: '00:00:00',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          black: 0,
          segmentOrder: index + i + 1,
          iframeToken: this.SingularMessage.flowicsToken,
          iframeInfoParams: {
            id: data.value[2],
            // name: 'Logo',
            state: 'in',
            type: 1,
            title: v.id,
            value: v.value,
            sceneId: data.value[0],
            regionId: data.value[1]
          }
        }
        this.tableData.splice(index + i + 1, 0, obj)
        this.UnderplayClipList[item.blockId] += 1
        // 推送操作
        this.PushUndo()
      })
    },
    // 删除行
    deleteRow (row, index) {
      if ((row.segmentId == 2 || row.segmentId == 11 || row.segmentId == 14) && row.eventOperationType == 'Underplay Block') {
        if (row.UnderplayClip) {
          this.tableData.splice(index, this.UnderplayClipList[row.blockId])
        } else {
          this.tableData.splice(index, 1)
          this.UnderplayClipList[row.blockId] -= 1
        }
      } else if (row.segmentId == 13 && (row.eventOperationType == 'Flowics' || row.eventOperationType == 'Singular')) {
        this.tableData.splice(index, this.UnderplayClipList[row.blockId])
      } else {
        this.tableData.splice(index, 1)
      }
      this.changeTableData()
      // 推送操作
      this.PushUndo()
    },
    // 新增行
    addRow (index, itemObj) {
      // if(itemObj)
      let eventIndex = index
      if (itemObj && (itemObj.segmentId == 2 || itemObj.segmentId == 11 || itemObj.segmentId == 14) && itemObj.eventOperationType == 'Underplay Block') {
        eventIndex = this.UnderplayClipList[itemObj.blockId] + index - 1
      } else if (itemObj && itemObj.segmentId == 13 && (itemObj.eventOperationType == 'Flowics' || itemObj.eventOperationType == 'Singular')) {
        eventIndex = this.UnderplayClipList[itemObj.blockId] + index - 1
      }
      const obj = {
        segmentId: null,
        eventOperationType: '',
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: eventIndex + 1
      }

      this.dragIndex = eventIndex
      this.tableData.splice(eventIndex + 1, 0, obj)
      // 推送操作
      this.PushUndo()
    },
    // 新增flowics
    addFlowics (item, index) {
      const obj = {
        segmentId: item.segmentId,
        eventOperationType: item.eventOperationType,
        blockId: item.blockId,
        flowics: 1,
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: index + this.UnderplayClipList[item.blockId]
      }
      this.tableData.splice(index + this.UnderplayClipList[item.blockId], 0, obj)
      this.UnderplayClipList[item.blockId] += 1
      // 推送操作
      this.PushUndo()
    },
    // 新增addUnderplayClip
    addUnderplayClip (item, index) {
      const obj = {
        segmentId: item.segmentId,
        eventOperationType: item.eventOperationType,
        blockId: item.blockId,
        UnderplayClip: 0,
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: index + this.UnderplayClipList[item.blockId]
      }
      this.tableData.splice(index + this.UnderplayClipList[item.blockId], 0, obj)
      this.UnderplayClipList[item.blockId] += 1
      // 推送操作
      this.PushUndo()
    },
    // scte类型选择
    changeScteEvent (obj) {
      const itemObj = this.tableData[obj.index]
      itemObj.eventOperationType = obj.val
      itemObj.blockId = ''
      itemObj.UnderplayClip = ''
      itemObj.sourceId = ''
      itemObj.fileId = ''
      itemObj.fileName = ''
      itemObj.sonEventMediaDuration = 0
      itemObj.timingIn = 0
      itemObj.timingOut = this.form.scteSpliceDurationDefault
      if ((itemObj.segmentId == 2 || itemObj.segmentId == 11 || itemObj.segmentId == 14) && itemObj.eventOperationType == 'Underplay Block') {
        itemObj.blockId = Outil.return32Str()
        itemObj.UnderplayClip = 1
        this.UnderplayClipList[itemObj.blockId] = 1
      } else if ((itemObj.segmentId == 2 || itemObj.segmentId == 11 || itemObj.segmentId == 14) && itemObj.eventOperationType == 'Underplay clip') {
        this.getTemplate(obj.index, 1)
        return
      }
      this.tableData.splice(obj.index, 1, itemObj)
      this.changeTableData()
      // 推送操作
      this.PushUndo()
    },
    // 获取默认scte视频文件
    getTemplate (index, type) {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/templates'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.enableUnderplayClip) {
              if (!type) {
                this.tableData[index].eventOperationType = 'Underplay clip'
              }
              const pitchOnFile = {
                ...result.fileInfo,
                id: result.fileInfo.fileId
              }
              this.changeFile(pitchOnFile, 2, index)
            } else if (!type) {
              const itemObj = this.tableData[index]
              itemObj.eventOperationType = 'Scte only'
              itemObj.sourceId = ''
              itemObj.fileId = ''
              itemObj.fileName = ''
              itemObj.sonEventMediaDuration = 0
              this.tableData.splice(index, 1, itemObj)
              this.changeTableData()
              // 推送操作
              this.PushUndo()
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    // 获取singular属性信息
    getSingularInfo () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      if (!this.SingularMessage.token) {
        this.$message.info(this.$t('lang.TokenNotExist'))
        return
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/singular/info', {
        iframeToken: this.SingularMessage.token,
        programId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.singularSelectList = result
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    singularSelect (item, index) {
      this.tableData = this.tableData.filter(v => {
        return (v.blockId != item.blockId) || (v.singularInfoParams.type == 0) || (v.singularInfoParams.type == 2)
      })
      this.UnderplayClipList[item.blockId] = 1
      const singularItem = this.singularSelectList.filter(v => v.subCompositionName == item.singularInfoParams.subCompositionName)
      const payloadList = Object.keys(singularItem[0].payload)
      const testList = ['title', 'text', 'name', 'string']
      this.numTimes = 0
      if (payloadList.length) {
        payloadList.forEach((v, i) => {
          const IsContain = testList.some(value => v.toLowerCase().includes(value))
          if (IsContain) {
            this.numTimes += 1
            const obj = {
              segmentId: item.segmentId,
              eventOperationType: item.eventOperationType,
              blockId: item.blockId,
              flowics: 0,
              fileId: '',
              timingIn: 0,
              timingInTime: '00:00:00',
              timingOut: 0,
              timingOutTime: '00:00:00',
              accumulatedProgramTiming: 0,
              suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
              duration: 0,
              black: 0,
              segmentOrder: index + this.numTimes,
              singularInfoParams: {
                subCompositionName: singularItem[0].subCompositionName,
                state: 'in',
                type: 1,
                payloadKey: v,
                payloadValue: singularItem[0].payload[v]
              }
            }
            this.tableData.splice(index + this.numTimes, 0, obj)
            this.UnderplayClipList[item.blockId] += 1
          }
        })
        item.singularInfoParams.type = this.numTimes ? 0 : 2
      } else {
        item.singularInfoParams.type = 2
      }
    },
    changeTimeSignal (obj, type) {
      const itemObj = this.tableData[obj.index]
      if (type == 'TimeSignal') {
        itemObj.fileId = obj.val
        itemObj.fileName = obj.val
        this.tableData.splice(obj.index, 1, itemObj)
      } else {
        if (obj.val == 'Flowics') {
          itemObj.blockId = Outil.return32Str()
          this.UnderplayClipList[itemObj.blockId] = 1
          itemObj.iframeToken = this.SingularMessage.flowicsToken
        } else if (obj.val == 'Singular') {
          itemObj.blockId = Outil.return32Str()
          this.UnderplayClipList[itemObj.blockId] = 1
          // this.getSingularInfo()
        }
        itemObj.eventOperationType = obj.val
        this.tableData.splice(obj.index, 1, itemObj)
        this.changeTableData()
      }
      // 推送操作
      this.PushUndo()
    },
    // 获取ExtGfx信息
    getExtGfx () {
      this.axios
        .post(Outil.getUrl('/singular/getSingular'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.SingularMessage = result
            // this.getSingularInfo()
            if (this.SingularMessage.singularStatus == 2 && this.SingularMessage.flowicsToken) {
              if (this.config.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) return
              this.config.logoConfig.push({
                value: 'Flowics',
                label: 'Flowics'
              })
            } else {
              if (this.config.logoConfig.some(v => {
                return v.value == 'Flowics'
              })) {
                this.config.logoConfig.splice(this.config.logoConfig.findIndex(item => item.value === 'Flowics'), 1)
              }
            }
            if (!this.SingularMessage.singularStatus) {
              if (this.config.logoConfig.some(v => {
                return v.value == 'Singular'
              })) return
              this.config.logoConfig.push({
                value: 'Singular',
                label: 'Singular'
              })
            } else {
              if (this.config.logoConfig.some(v => {
                return v.value == 'Singular'
              })) {
                this.config.logoConfig.splice(this.config.logoConfig.findIndex(item => item.value === 'Singular'), 1)
              }
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch((e) => {
          console.log(e)
        })
    },
    // 子事件类型变化
    async changeSegment (obj) {
      const itemObj = this.tableData[obj.index]
      itemObj.segmentId = obj.val
      itemObj.eventOperationType = ''
      // 如果是ReferenceMedia，In应该默认为上一次主视频结束时间，Out为视频总时长
      // 如果是SCTE类型，duration为统一设置的默认值
      if (obj.val == 1) {
        const referenceMediaArr = this.tableData.filter((item) => item.segmentId == 1)
        itemObj.timingIn = referenceMediaArr.length > 1 ? referenceMediaArr[referenceMediaArr.length - 2].timingOut : 0
        itemObj.timingOut = itemObj.timingIn
      } else if (obj.val == 2 || obj.val == 11 || obj.val == 14) {
        itemObj.timingIn = 0
        itemObj.timingOut = this.form.scteSpliceDurationDefault
        this.getTemplate(obj.index, 0)
        return
        // itemObj.eventOperationType = 'Scte only'
      } else if (obj.val == 13) {
        itemObj.offsetFrom = 0
        itemObj.offsetTo = 0
        itemObj.eventOperationType = 'Logo'
        itemObj.iframeInfoParams = {
          id: '',
          // name: 'Logo',
          // state: 'in',
          type: '',
          title: '',
          value: '',
          sceneId: '',
          regionId: ''
        }
        itemObj.singularInfoParams = {
          subCompositionName: '',
          state: 'in',
          type: 0,
          payloadKey: '',
          payloadValue: ''
        }
      } else {
        itemObj.timingIn = 0
        itemObj.timingOut = 0
      }
      itemObj.sourceId = ''
      itemObj.fileId = ''
      itemObj.fileName = ''
      itemObj.sonEventMediaDuration = 0
      this.tableData.splice(obj.index, 1, itemObj)
      this.changeTableData()
      // 推送操作
      this.PushUndo()
    },
    // 模板Duration变化监听
    DurationChange () {
      // 类型为Live时
      if (this.form.sourceType) {
        this.form.mediaTotalTime = this.programDuration * 60
        this.TimeReferenceMedia(this.form.mediaTotalTime)
      }
      this.changeTableData()
      this.PushUndo('inputEnd')
    },
    // scte时间变化
    ScteDurationChange () {
      if (typeof this.form.scteSpliceDurationDefault == 'string') {
        this.form.scteSpliceDurationDefault = this.form.scteSpliceDurationDefault.replace(/[^\d]/g, '')
        this.form.scteSpliceDurationDefault = Number(this.form.scteSpliceDurationDefault)
      }
      this.changeTableData(this.form.scteSpliceDurationDefault)
      // 推送操作
      this.PushUndo()
    },
    // 重新计算
    changeTableData (scteSuration) {
      let totalDuration = 0
      this.scteTimes = 0
      this.form.scteTotalTime = 0
      this.form.blackTime = 0
      const indexArr = []
      this.tableData.forEach((item, i) => {
        if (item.segmentId == 1) indexArr.push(i)
      })
      let SerialNumber = 0
      let parent = {}
      let lastEvent = {}
      const tableData = this.tableData
      tableData.forEach((itm, index) => {
        if (itm.segmentId != 13) {
          // 计算序号
          if (itm.segmentId == 1) {
            SerialNumber++
            itm.SerialNumber = SerialNumber
          }
          // 如果是SCTE Program End则开始和结束时间都等于上一条数据的timeOut
          // 需要传给后台的排序
          itm.segmentOrder = index
          if (itm.segmentId == 7 && index != 0) {
            itm.timingIn = lastEvent.accumulatedProgramTiming
            itm.timingOut = lastEvent.accumulatedProgramTiming
          }
          // 切换SCTE duration时直接修改列表中SCTE的timeOut
          if (scteSuration && (itm.segmentId == 2 || itm.segmentId == 11 || itm.segmentId == 14) && itm.eventOperationType == 'Scte only') {
            itm.timingOut = itm.timingIn + scteSuration
          }
          itm.timingInTime = itm.timingIn == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingIn * 1000)}`
          itm.timingOutTime = itm.timingOut == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingOut * 1000)}`
          itm.duration = itm.timingOut - itm.timingIn
          // if (itm.segmentId == 1 && itm.black) {
          //     itm.accumulatedProgramTiming = index == 0? itm.duration : this.tableData[index - 1].accumulatedProgramTiming + itm.duration + itm.black
          //     totalDuration += (itm.duration + itm.black)
          // } else {
          itm.accumulatedProgramTiming = index == 0 ? itm.duration : lastEvent.accumulatedProgramTiming + itm.duration
          totalDuration += itm.duration
          // }
          if (itm.segmentId == 2 || itm.segmentId == 11 || itm.segmentId == 14) {
            this.scteTimes += 1
            this.form.scteTotalTime += itm.duration
          }
          if (itm.segmentId == 9) {
            this.form.blackTime += itm.duration
          }
          // Underplay Block时间为一组时间
          if (itm.eventOperationType == 'Underplay Block' && parent.eventOperationType == 'Underplay Block' && itm.blockId == parent.blockId) {
            parent.timingOut = parent.timingOut + itm.duration
          } else {
            parent = JSON.parse(JSON.stringify(itm))
          }
          lastEvent = itm
        } else {
          itm.segmentOrder = index
          itm.timingIn = itm.offsetFrom + parent.timingIn
          itm.timingOut = itm.offsetTo + parent.timingOut
          itm.timingInTime = itm.timingIn == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingIn * 1000)}`
          itm.timingOutTime = itm.timingOut == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingOut * 1000)}`
          itm.duration = itm.timingOut - itm.timingIn
        }
      })
      this.tableData = this.objDeepCopy(tableData)
      this.form.templateVideoTotalTime = totalDuration
      if (this.programDuration * 60 >= this.form.templateVideoTotalTime) {
        this.overTimeFlag = false
        this.form.overUnderTime = this.programDuration * 60 - this.form.templateVideoTotalTime
      } else {
        this.overTimeFlag = true
        this.form.overUnderTime = this.form.templateVideoTotalTime - this.programDuration * 60
      }
    },
    // 初始化数据
    initFormData (obj) {
      if (obj.type != '') {
        this.operateType = obj.type
      }
      if (obj.type == 'add') {
        this.operateId = ''
        this.form = {
          templateName: '',
          series: '',
          episodeTitle: '',
          episode: 1,
          season: 0,
          houseId: '',
          sourceType: 0,
          referenceMediaId: '',
          referenceMediaName: '',
          mediaTotalTime: 0, // 对应TRT
          templateVideoTotalTime: 0,
          blackTime: 0,
          addEventSegments: [],
          updateEventSegments: [],
          deleteEventSegments: [],
          timingId: '',
          scteSpliceDurationDefault: 90,
          scteTotalTime: 0,
          overUnderTime: 30 * 60,
          description: '',
          occasionalOutputMessage: [],
          category: '',
          thumbnail: '',
          treeId: ''
        }
        this.occasionalOutputMessage = true
        let timingOut,
          timingOutTime
        if (this.allowZeroDuration) {
          timingOut = 0,
          timingOutTime = '00:00:00'
        } else {
          timingOut = 1,
          timingOutTime = '00:00:01'
        }
        this.tableData = [{
          segmentId: 6,
          eventOperationType: '',
          timingIn: 0,
          timingInTime: '00:00:00',
          timingOut,
          timingOutTime,
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 0
        },
        {
          segmentId: 1,
          eventOperationType: '',
          timingIn: 0,
          timingInTime: '00:00:00',
          timingOut: 0,
          timingOutTime: '00:00:00',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 1
        },
        {
          segmentId: 7,
          eventOperationType: '',
          timingIn: 1,
          timingInTime: '00:00:01',
          timingOut: 1,
          timingOutTime: '00:00:01',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 2
        }]
        this.changeTableData()
        // 推送操作
        this.PushUndo()
      } else {
        if (obj.tag == 'tem') {
          this.operateId = obj.data.id
          this.form.timingId = ''
          this.programDuration = 30
        }
        this.getTemInfoById(obj.data.id, obj.tag, obj.data.TemplateType)
      }
    },
    // timing滚动加载
    getNextPage () {
      if (this.bindScroll.loading || this.bindScroll.noMore) return
      this.McpObj.pageNum += 1
      this.getMcpList()
    },
    cancel () {
      this.$emit('closeProgramTemplate')
      Bus.$emit('regDrag')
    },
    // 深copy
    objDeepCopy (source) {
      var sourceCopy = source instanceof Array ? [] : {}
      for (var item in source) {
        sourceCopy[item] = typeof source[item] === 'object' && source[item] != null ? this.objDeepCopy(source[item]) : source[item]
      }
      return sourceCopy
    },
    // 搜索source
    SearchSource (value) {
      this.SourcePaging.pageNum = 0
      this.SourcePaging.condition = value
      this.SourcePaging.loadEnd = false
      this.getSourceList()
    },
    // 获取source列表
    getSourceList () {
      this.SourcePaging.pageNum++
      this.SourcePaging.programId = this.$BehaviorSyns.getProgramId()
      if (!this.SourcePaging.loadEnd) {
        this.axios.post(Outil.getUrl('/device/pageSourceDevice'), this.SourcePaging)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.errorCode == '0x0') {
                const { result } = res.data
                if (result.list) {
                  if (this.SourcePaging.pageNum == 1) {
                    this.SourceList = result.list
                  } else {
                    this.SourceList.push(...result.list)
                  }
                }
                if (result.list.length < 35) {
                  this.SourcePaging.loadEnd = true
                }
              } else {
                const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                this.$message.info(errorInfo)
              }
            }
          }).catch(() => {})
      }
    },
    // 是否有外部s3
    getStorage () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/storage'),
        data: {
          programId: ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.enableExternalS3) {
              this.SettingParams('update')
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取多选择组件配置
    GetConfigParams () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.AllConfigParams = SourceConfigParams(programId, this.RegionInfo.bucket)
      this.getStorage()
      this.SettingParams()
    },
    // 设置显示参数
    SettingParams (type) {
      if (type == 'update') {
        this.MediaLiveParams = {
          List: {
            Live: this.AllConfigParams.Live,
            Media: this.AllConfigParams.Media,
            AmazonS3: this.AllConfigParams.AmazonS3
          },
          search: this.AllConfigParams.search
        }
        this.MediaParams = {
          List: {
            Media: this.AllConfigParams.Media,
            AmazonS3: this.AllConfigParams.AmazonS3
          },
          search: this.AllConfigParams.search
        }
      } else {
        this.MediaLiveParams = {
          List: {
            Live: this.AllConfigParams.Live,
            Media: this.AllConfigParams.Media
          },
          search: this.AllConfigParams.search
        }
        this.MediaParams = {
          List: {
            Media: this.AllConfigParams.Media
          },
          search: this.AllConfigParams.search
        }
      }
      this.LiveParams = {
        List: {
          Live: this.AllConfigParams.Live
        },
        search: this.AllConfigParams.search
      }
    },
    // 只允许数字
    onlyNumbers (key) {
      if (key == 'Season') {
        const inputValue = this.form.season
        this.form.season = inputValue.replace(/[^0-9]/g, '')
      } else if (key == 'Episode') {
        const inputValue = this.form.episode
        this.form.episode = inputValue.replace(/[^0-9]/g, '')
      }
      this.PushUndo('input')
    }
  },
  beforeDestroy () {
    Bus.$off('refreshFileList')
    this.UndoActionPro.stop()
    Bus.$off('leftListUpdate', this.registerDrag)
    Bus.$off('regDrag')
    Bus.$off('closeTemplate')
  }
}
</script>
<style lang="less" scoped>
.TemplateForm{
  height: calc(100% - 65px);
  overflow-y: auto;
}
.template-box {
  width: 99%;
  padding: 40px 20px 10px;
  margin: 0;
  .el-form-item {
    margin: 0 0 10px;
    ::v-deep .el-form-item__label {
      width: 150px !important;
      padding: 0;
      white-space: nowrap;
    }
    ::v-deep .el-form-item__content {
      text-align: left;
      min-width: 150px;
      .el-form-item__error {
        padding-top: 0;
        line-height: 6px;
      }
      .el-input-group--append {
        input {
          border-right: none;
        }
        .el-input-group__append {
          background: rgb(68, 68, 68);
          border: 1px solid #444;
          border-left: none;
        }
      }
      .el-textarea__inner {
        background: #444;
        border: 1px solid #444;
        color: #fff;
      }
      .desc{
        position: relative;
        .desNum{
          position: absolute;
          bottom: 2px;
          right: 2px;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
      }
    }
    &.timingFile {
      .el-form-item__content {
        position: relative;
        .timing-item {
          width: 90%;
          display: inline-block;
        }
      }
    }
    &.referenceFile,
    &.timingFile {
      ::v-deep .el-select {
        .el-select-dropdown {
          width: 100%;
        }
      }
    }
    ::v-deep .ReferenceMedia {
      display: flex;
      .PublicMultipleSelect{
        min-width: 150px;
      }
      .PrimarySource{
        width: calc(50% - 75px);
      }
      .Link {
        margin-left: 10px;
        color: #666666;
      }
      .SecondarySource {
        width: calc(50% + 75px);
        margin-left: 5px;
        display: flex;
        .PublicMultipleSelect{
          width: calc(100% - 120px);
        }
        .SecondaryHint {
          white-space: nowrap;
          font-size: 14px;
          color: #606266;
          width: 120px;
          margin-right: 30px;
          text-align: right;
        }
      }
      .el-input--suffix {
        .el-input__suffix {
          width: 23px;
          right: 0px;
        }
        .el-input__inner {
          height: 34px;
          line-height: 34px;
          color: #dbdbdb;
          padding-left: 8px;
          padding-right: 15px;
        }
      }
    }
  }
  .referenceMediaName{
    overflow: hidden;
    height: 50px;
    display: inline-block;
  }
  .UnderplayClipVideo{
    display: flex;
    .PublicFileSelect{
      width: 85%;
    }
    .addUnderplayClip{
      width: 10%;
      margin-left: 5px;
    }
  }
  .Secondary{
    display: flex;
    .flowicsSelect{
     width: 85%;
    }
    .flowicsAdd{
      width: 10%;
      margin-left: 5px;
    }
    .logoAndHashValue{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  ::v-deep .ScteDuration {
    position: relative;
    .el-input__inner{
      padding-right: 100px;
    }
    .unit{
      position: absolute;
      right: 10px;
      top: 0px;
    }
  }
  ::v-deep .Thumbnails {
    .el-input__inner {
      color: #44A4FD;
    }
  }
  .CustomMetadataEdit{
    .icon-bianji{
      font-size: 12px;
    }
  }
  ::v-deep .el-select {
    width: 100%;
    .el-select-dropdown__item {
      padding: 0 20px 0 20px;
      .deltete-icon {
        display: none;
      }
      &.hover {
        .deltete-icon {
          display: inline-block;
        }
      }
    }
  }
  ::v-deep .el-table {
     overflow: visible;
     margin-top: 0px;
    .el-table__body-wrapper {
      overflow: visible;
    }
    table {
      min-height: 50px;
    }
    .el-table__row {
      .timePicker{
        position: relative;
        .SecondaryOffset{
          width: 100%;
          height: 30px;
          position: absolute;
          top: 10px;
          left: 0;
          background: #444444;
          z-index: 1;
          color: #fff;
          line-height: 30px;
          font-size: 14px;
          padding-left: 8px;
        }
      }
      td {
        // z-index: 1;
        .cell {
          overflow: visible;
          // .logoAndHashText{
          //   text-align: center;
          // }
        }
      }
      th .cell {
        height: 40px;
        line-height: 40px;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
      .leftM {
        margin-left: 20px;
      }
    }
  }
  ::v-deep .el-input {
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border: 1px solid #444;
      background: rgb(68, 68, 68);
    }
  }
  ::v-deep .el-scrollbar__wrap {
    height: 214px !important;

    .el-scrollbar__view {
      height: fit-content;
      // height: 210px !important;
      // width: 100%;
      // overflow-y: auto;

      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background-color: rgba(144, 147, 153, 0.2);
        opacity: 0.7;
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: none;
      }
    }
  }
  .line {
    clear: both;
    background-color: #444;
    height: 4px;
  }
  .calculate-info {
    // width: 80%;
    height: 90px;
    margin: 0 auto;
    ::v-deep .el-form-item {
      height: 30px;
      .el-form-item__label,
      .el-form-item__content {
        height: 30px;
        line-height: 30px;
      }
    }
  }
  .add-icon {
    float: right;
    .i-add:before {
      font-size: 20px;
    }
    &.notAllowed {
      .i-add:before {
        cursor: not-allowed;
      }
    }
  }
  .footer {
    height: 60px;
    line-height: 60px;
    width: 100%;
    text-align: right;
    padding-right: 40px;
    position: absolute;
    bottom: 0;
    right: 0;
    background: #252525;
    border-top: 1px solid #000;
    .el-button {
      padding: 7px 20px;
      &.delete {
        margin-right: 50px;
        background: #252525;
        border: 1px solid #524c4c;
      }
    }
  }
  .notAllowed {
    cursor: not-allowed !important;
    &:hover {
      color: #fff;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
